<div [style]="{ 'min-height': '50vh' }">
	<div class="row">
		<!--
    <p-panel>
      <ng-template pTemplate="header">
        <div class="header-content" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
          <span style="font-size: 18px; flex-grow: 1;">Título</span>
          
          <div style="display: flex; align-items: center;">
            <i class="pi pi-user" style="font-size: 16px; margin-right: 10px;"></i>
            <span>Subtítulo 1</span>
            <i class="pi pi-cog" style="font-size: 16px; margin-left: 20px; margin-right: 10px;"></i>
            <span>Subtítulo 2</span>
          </div>

           <i class="pi pi-arrow-down" style="font-size: 16px; cursor: pointer;"></i>
        </div>
      </ng-template>

       <div>
        Contenido del panel.
      </div>
    </p-panel>
    -->
		<div class="accordion-notifications">
			<p-accordion [multiple]="true">
				<ng-container *ngFor="let notification of notifications">
					<p-accordionTab [(selected)]="notification.isSelected">
						<ng-template pTemplate="header">
							<div *ngTemplateOutlet="headerNotification; context: { notification: notification }"></div>
						</ng-template>
						<div *ngTemplateOutlet="bodyNotification; context: { notification: notification }"></div>
					</p-accordionTab>
				</ng-container>

				<!-- PEDIDO EN CAMINO -->
				<!--
        <p-accordionTab [(selected)]="notificationTypesActive[1]">
          <ng-template pTemplate="header">
            <div
              *ngTemplateOutlet="headerNotification; context: {title: 'Pedido En camino', mail: false, sms: false, headerSelected: notificationTypesActive[1]}">
            </div>
          </ng-template>
          <div 
            *ngTemplateOutlet="bodyNotification">
          </div>
        </p-accordionTab>
        -->
			</p-accordion>
		</div>
	</div>
</div>

<ng-template #headerNotification let-notification="notification">
	<div class="header-content" style="display: flex; justify-content: space-between; align-items: center; width: 100%">
		<span style="font-size: 16px; flex-grow: 1">{{
			'administration.customers.notification.' + notification.type | translate
		}}</span>
		<div style="display: flex; align-items: center">
			<i
				class="pi"
				[ngClass]="{
					'true-icon pi-check-circle': notification.notifyByEmail,
					'false-icon pi-times-circle': !notification.notifyByEmail
				}"
				[ngStyle]="{ color: notification.isSelected ? 'white' : notification.notifyByEmail ? 'green' : 'red' }"
				style="font-size: 1.5rem; margin-right: 10px"
			></i>
			<span>{{ 'alerts.sendEmail' | translate }}</span>

			<i
				class="pi"
				[ngClass]="{
					'true-icon pi-check-circle': notification.notifyBySMS,
					'false-icon pi-times-circle': !notification.notifyBySMS
				}"
				[ngStyle]="{ color: notification.isSelected ? 'white' : notification.notifyBySMS ? 'green' : 'red' }"
				style="font-size: 1.5rem; margin-right: 10px; margin-left: 20px"
			></i>

			<span>{{ 'alerts.sendSMS' | translate }}</span>
		</div>
	</div>
</ng-template>

<ng-template #bodyNotification let-notification="notification">
	<div style="padding-top: 10px; padding-bottom: 20px">
		<!-- MAIL -->
		<div style="display: flex; align-items: center; justify-content: space-between; margin: 5px 10px 10px 10px">
			<div style="display: flex; align-items: center">
				<label for="emailSwitch" style="font-weight: bold; font-size: 17px">
					{{ 'alerts.sendEmail' | translate }}
				</label>
				<p-inputSwitch style="margin-left: 30px" [(ngModel)]="notification.notifyByEmail"></p-inputSwitch>
			</div>

			<span style="color: grey; font-size: 14px">
 				Pulse @ para añadir variables
			</span>
		</div>
		<div>
			<div *ngIf="notification.type">
				<app-custom-quill-editor
					placeholder="{{ 'administration.customers.notification.affair' | translate }}"
					[mentionsOptions]="notification.params.mailSubject"
					[(editorValue)]="notification.mailSubject"
					[toolbar]="[]"
					[editorHeight]="'40px'"
				></app-custom-quill-editor>
			</div>
		</div>
		<!-- [mentionsOptions]="NotificationParamsMap[notification.type]?.mailSubject" -->
		<div style="margin-top: 10px">
			<app-custom-quill-editor
				placeholder="{{ 'administration.customers.notification.writetext' | translate }}"
				[toolbar]="mailToolbar"
				[editorHeight]="'200px'"
				[mentionsOptions]="notification.params.mail"
				[(editorValue)]="notification.mailBody"
			></app-custom-quill-editor>
		</div>
		<!--[mentionsOptions]="NotificationParamsMap[notification.type]?.mail"-->
		<!--SMS -->
		<div style="display: flex; align-items: center; margin: 30px 0px 10px 10px">
			<label for="emailSwitch" style="font-weight: bold; font-size: 17px">{{ 'alerts.sendSMS' | translate }}</label>
			<p-inputSwitch style="margin-left: 30px" [(ngModel)]="notification.notifyBySMS"></p-inputSwitch>
		</div>
		<div>
			<app-custom-quill-editor
				[maxLength]="160"
				[(editorValue)]="notification.smsMessage"
				placeholder="{{ 'administration.customers.notification.writesms' | translate }}"
				[toolbar]="[]"
				[editorHeight]="'50px'"
			></app-custom-quill-editor>
			<!--[mentionsOptions]="NotificationParamsMap[notification.type]?.sms" -->
		</div>
		<div style="text-align: right; margin-top: 15px">
			<button class="btn custom-button" (click)="saveNotification(notification)" i18n>
				{{ 'general.save' | translate }}
			</button>
		</div>
	</div>
</ng-template>

<ng-template #rightSaveButton> </ng-template>
